/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// @mui material components
import Card from '@mui/material/Card'
import { signOut } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'

import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'
import { auth } from 'config/firebase'
import { ROUTE_PATHS } from 'routes'

function Logout(): JSX.Element {
	const navigate = useNavigate()

	const handleOnLogoutClick = () => {
		signOut(auth)
			.then(() => {
				navigate(ROUTE_PATHS.AUTHENTICATION.SIGN_IN)
			})
			.catch(error => {
				console.error('Error signing out:', error)
			})
	}
	return (
		<Card id="delete-account">
			<MDBox
				pr={3}
				display="flex"
				justifyContent="space-between"
				alignItems={{ xs: 'flex-start', sm: 'center' }}
				flexDirection={{ xs: 'column', sm: 'row' }}
			>
				<MDBox p={3} lineHeight={1}>
					<MDBox mb={1}>
						<MDTypography variant="h5">Log Out</MDTypography>
					</MDBox>
				</MDBox>
				<MDBox display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
					<MDBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }} sx={{ width: '150px' }}>
						<MDButton
							variant="outlined"
							color="error"
							sx={{ height: '100%', width: '100%' }}
							onClick={handleOnLogoutClick}
						>
							Logout
						</MDButton>
					</MDBox>
				</MDBox>
			</MDBox>
		</Card>
	)
}

export default Logout
